// extracted by mini-css-extract-plugin
export default {"cls1":"Base-cls1__01","cls2":"Base-cls2__it Base-cls1__01"};